import {TServerError} from 'core/types';

export const checkIsCorrectErrors = (errors: TServerError[]) => {
    return Boolean(0 < errors?.length && errors[0].message && errors[0].code);
};
